import { Card } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { IStoreTableData } from '../utils';
import { EmptyState, LoadingState } from '../shared';

interface StoreTableProps {
  data: IStoreTableData[];
  isFetching: boolean;
  title?: string;
}

export default function StoreTable({
  data,
  isFetching,
  title = "Status das NFCe por Loja"
}: StoreTableProps) {
  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4 text-center">{title}</h2>
      <div className="w-full">
        {isFetching ? (
          <LoadingState />
        ) : data.length > 0 ? (
          <div className="max-h-[600px] overflow-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="sticky top-0 bg-white">Loja</TableHead>
                  <TableHead className="sticky top-0 bg-white text-right">Sucesso</TableHead>
                  <TableHead className="sticky top-0 bg-white text-right">Contingência</TableHead>
                  <TableHead className="sticky top-0 bg-white text-right">Cancelado</TableHead>
                  <TableHead className="sticky top-0 bg-white text-right">Pendente</TableHead>
                  <TableHead className="sticky top-0 bg-white text-right font-bold">Total</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data.map((item) => (
                  <TableRow key={item.STORE}>
                    <TableCell className="font-medium">
                      Loja {String(item.STORE).padStart(3, '0')}
                    </TableCell>
                    <TableCell className="text-right tabular-nums">
                      <div className="flex items-center justify-end gap-2">
                        <div className="w-2 h-2 rounded-full bg-green-500"></div>
                        <span className="font-medium text-green-700">{item.Sucesso.toLocaleString()}</span>
                      </div>
                    </TableCell>
                    <TableCell className="text-right tabular-nums">
                      <div className="flex items-center justify-end gap-2">
                        <div className="w-2 h-2 rounded-full bg-yellow-500"></div>
                        <span className="font-medium text-yellow-700">{item.Contingência.toLocaleString()}</span>
                      </div>
                    </TableCell>
                    <TableCell className="text-right tabular-nums">
                      <div className="flex items-center justify-end gap-2">
                        <div className="w-2 h-2 rounded-full bg-red-500"></div>
                        <span className="font-medium text-red-700">{item.Cancelado.toLocaleString()}</span>
                      </div>
                    </TableCell>
                    <TableCell className="text-right tabular-nums">
                      <div className="flex items-center justify-end gap-2">
                        <div className="w-2 h-2 rounded-full bg-gray-500"></div>
                        <span className="font-medium text-gray-700">{item.Pendente.toLocaleString()}</span>
                      </div>
                    </TableCell>
                    <TableCell className="text-right tabular-nums font-bold">
                      {item.Total.toLocaleString()}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        ) : (
          <EmptyState
            title="Nenhum dado disponível para exibição"
            description="Use os filtros acima para carregar os dados da tabela"
          />
        )}
      </div>
    </Card>
  );
}